<template>
  <div>
    <div class="processPrize-box">
      <div class="processPrize-imgbox">
        <img class="processPrize-img" src="/static/youyuefuwu.jpg"/>
      </div>

      <div class="processPrize-process">1、扫描二维码关注“<span style="color: #029dff;">优越服务</span>”公众号</div>
       <div class="processPrize-process">2、点击“<span style="color: #029dff;">领取专区</span>”进入领取奖品页面</div>
       <div class="processPrize-process">3、输入账号进行奖品充值</div>
       <div class="processPrize-process1">提示：未绑定手机号进入页面需要先绑定手机号码才可进行奖品充值</div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{

      }
    },
    created() {

    },
    mounted() {

    },
    methods:{

    }
  }
</script>

<style>
  .processPrize-box{
    display: flex;
    /* align-items: center; */
    justify-content: center;
    flex-direction: column;
    width: calc(100% - 40px);
    margin: 20% 20px 0 20px;
  }
  .processPrize-imgbox{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    width: 100%;
  }
  .processPrize-img{
    width: 150px;
    height: 150px;
  }
  .processPrize-process{
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .processPrize-process1{
    font-size: 15px;
    color: #ea6e56;
  }
</style>



// WEBPACK FOOTER //
// src/pages/getPrize/processPrize.vue